/**
 * Custom hook to determine if a product/item is covered by employer supplement invoicing.
 *
 * The eligible_product_ids field uses these semantics:
 * - null/undefined: invoicing not available (no supplements covered)
 * - []: invoicing available, all supplements covered (when requires_recommendation is false)
 *       OR no recommendations exist (when requires_recommendation is true — nothing covered)
 * - [id1, id2]: invoicing available, only these products covered (recommendation required)
 *
 * @param {Object} product - The product or cart item to check
 * @param {Object} cart - The current cart object
 * @returns {boolean} - Whether the product is an invoiced supplement
 */
export default function useInvoicedSupplement(product, cart) {
  if (!product || !cart) return false
  if (product.category !== 'supplement') return false

  const eligibleIds = cart.supplement_invoicing_eligible_product_ids

  // null/undefined means invoicing is not available
  if (eligibleIds == null) return false

  // Empty array: depends on whether recommendations are required
  // - requires_recommendation=true + empty = no recs, nothing covered
  // - requires_recommendation=false + empty = all supplements covered
  if (eligibleIds.length === 0) {
    return !cart.supplement_invoicing_requires_recommendation
  }

  // Non-empty array means only these specific products are covered
  return eligibleIds.includes(product.id)
}
